import { Button } from 'appkit-react';

import leftChevron from '../../assets/images/left-chevron.svg';
import FRY7QUploadTabTwo from './regulations/FRY7Q/FRY7QUploadTabTwo';
import Metro2UploadTabTwo from './regulations/METRO2/Metro2UploadTabTwo';
import FFIEC009UploadTabTwo from './regulations/FFIEC009/FFIEC009UploadTabTwo';
import FR2052AUploadTabTwo from './regulations/FR2052A/FR2052AUploadTabTwo';
import FRY9CUploadTabTwo from './regulations/FRY9C/FRY9CUploadTabTwo';
import FFFIEC031UploadTabTwo from './regulations/FFIEC031/FFIEC031UploadTabTwo';
import FFFIEC041UploadTabTwo from './regulations/FFIEC041/FFIEC041UploadTabTwo';

const UploadTabTwo = ({ setTab, selectValue }) => (
    <div className="true-comply-upload__steptwo" data-testid="tab-2">
        <div className="true-comply-upload__steptwo-back" onClick={() => setTab('first')} aria-hidden="true" data-testid="btn-back">
            <img src={leftChevron} alt="leftChevron" />
            Back
        </div>
        <div className="true-comply-upload__steptwo-head">
            <div className="true-comply-upload__steptwo-head-left">
                <div className="true-comply-upload__steptwo-head-left-title">Prepare your files</div>
                <div className="true-comply-upload__steptwo-head-left-subtext">Please take a moment to locate your file(s) and see if they meet the following requirements:</div>
            </div>
            <div className="true-comply-upload__steptwo-head-right">
                <Button className="true-comply-upload__steptwo-head-right-btn" onClick={() => setTab('third')} aria-hidden="true" data-testid="btn-next">Next</Button>
            </div>
            <div className="hr-line" />
        </div>
        {selectValue === 'FR Y-7Q' && (
            <FRY7QUploadTabTwo />
        )}
        {selectValue === 'FR Y-9C' && (
            <FRY9CUploadTabTwo />
        )}
        {selectValue === 'FFIEC 031' && (
            <FFFIEC031UploadTabTwo />
        )}
        {selectValue === 'FFIEC 041' && (
            <FFFIEC041UploadTabTwo />
        )}
        { selectValue === 'Metro2' && (
            <Metro2UploadTabTwo />
        )}
        { selectValue === 'FFIEC009' && (
            <FFIEC009UploadTabTwo />
        )}
        { selectValue === 'FR 2052a' && (
            <FR2052AUploadTabTwo />
        )}
    </div>
);

export default UploadTabTwo;
